/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { ParentLayout } from "../../../layout/parentLayout";
import NewSideBarParent from "../../../components/NewSideBarParent";
import { useGetInquiriesQuery } from "../../../service/inquiry";
import Loader from "../../../constants/Loader";
import moment from "moment";
import { TEASER_VIDEO_STATUS } from "../../../constants/enums";

export default function InquireyPage() {
  const { data: inquiries, isLoading } = useGetInquiriesQuery({
    page: 1,
    limit: 20,
  });
  const [selected, setSelected] = useState<any>({});

  return (
    <>
      <ParentLayout className="role-layout">
        <Loader isLoad={isLoading} />
        <main className="content">
          <section className="uh_spc inq_wrp home_wrp">
            <div className="conta_iner v2">
              <div className="gap_m grid_three">
                <NewSideBarParent />
                <ul className="cmn_crd_wp  inq_card md_ul">
                  {inquiries?.data?.data?.length
                    ? inquiries?.data?.data?.map((item: any, index: number) => {
                        return (
                          <li key={item?._id}>
                            <div
                              className="in_row"
                              onClick={() => setSelected(item)}
                            >
                              <figure>
                                <img
                                  src={
                                    item?.tutor?.image ||
                                    `/static/images/emaa.png`
                                  }
                                  alt="emaa"
                                />
                              </figure>
                              <div className="dsc">
                                <h4>
                                  {item?.tutor?.name || "-"}{" "}
                                  <span>
                                    {item?.createdAt
                                      ? moment(item?.createdAt).format("LLL")
                                      : ""}
                                  </span>{" "}
                                </h4>
                                <p>
                                  {item?.other?.length > 100
                                    ? item?.other?.slice(0, 100) + "..."
                                    : item?.other}
                                </p>
                              </div>
                            </div>
                            <span
                              className={`status ${item?.status == TEASER_VIDEO_STATUS.PENDING ? "pending" : item?.status == TEASER_VIDEO_STATUS.REJECTED ? "rejected" : ""} `}
                            >
                              {" "}
                              {item?.status == TEASER_VIDEO_STATUS.PENDING
                                ? "Pending"
                                : item?.status == TEASER_VIDEO_STATUS.APPROVED
                                  ? "Answered"
                                  : "Rejected"}
                            </span>
                          </li>
                        );
                      })
                    : "No inquiry found"}
                </ul>
                {selected?._id ? (
                  <div className="answer_sec sidebar_rt">
                    <ul className="cmn_crd_wp inq_card">
                      <li>
                        <div className="in_row">
                          <figure>
                            <img src={`/static/images/emaa.png`} alt="emaa" />
                          </figure>
                          <div className="dsc">
                            <h4>
                              {selected?.tutor?.name || ""}{" "}
                              <span>
                                {selected?.createdAt
                                  ? moment(selected?.createdAt).format("LLL")
                                  : ""}
                              </span>{" "}
                            </h4>
                            <p>{selected?.other || ""}</p>
                          </div>
                        </div>
                        {selected?.revert ? (
                          <div className="ans_bx">
                            <button className="btn primary">
                              Admin revert
                            </button>
                            {/* <h6>1:01 PM</h6> */}
                            <p>{selected?.revert || ""}</p>
                          </div>
                        ) : null}

                        {selected?.tutorRevert ? (
                          <div className="ans_bx">
                            <button className="btn primary">
                              Tutor revert
                            </button>
                            <p>{selected?.tutorRevert || ""}</p>
                          </div>
                        ) : null}
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </section>
        </main>
      </ParentLayout>
    </>
  );
}
